@if (status().connected) {
  <mat-icon class="!text-success !h-[0.85rem] !w-[0.85rem] !text-[0.85rem] !leading-none" fastTooltip="Connected to real-time update channel"
    >circle</mat-icon
  >
} @else {
  <mat-icon class="text-warning !h-[0.85rem] !w-[0.85rem] !text-[0.85rem] !leading-none" [fastTooltip]="status().reason">warning</mat-icon>
}
